import { render, staticRenderFns } from "./AddDVIRForm.vue?vue&type=template&id=08bfcde8&scoped=true&"
import script from "./AddDVIRForm.vue?vue&type=script&lang=js&"
export * from "./AddDVIRForm.vue?vue&type=script&lang=js&"
import style0 from "./AddDVIRForm.vue?vue&type=style&index=0&id=08bfcde8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bfcde8",
  null
  
)

export default component.exports